import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Menu', path: '/menu' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://public.readdy.ai/ai/img_res/007688b8-3d79-4152-adb5-396ec7a60c17.png" 
              alt="The Bridge Street Café" 
              className="h-12 w-auto"
            />
            <div className="hidden sm:block">
              <span className={`font-serif font-bold text-xl ${isScrolled ? 'text-[#3D2817]' : 'text-[#3D2817]'}`}>
                The Bridge Street Café
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-[#C17855]'
                    : isScrolled
                    ? 'text-[#3D2817] hover:text-[#C17855]'
                    : 'text-[#3D2817] hover:text-[#C17855]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/contact"
              className="px-6 py-3 bg-[#C17855] text-white rounded-full font-medium hover:bg-[#A66545] transition-colors whitespace-nowrap cursor-pointer"
            >
              Visit Us
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-[#3D2817] cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-6 bg-white border-t border-gray-200">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`px-4 py-2 font-medium transition-colors cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-[#C17855]'
                      : 'text-[#3D2817] hover:text-[#C17855]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="mx-4 px-6 py-3 bg-[#C17855] text-white rounded-full font-medium text-center hover:bg-[#A66545] transition-colors whitespace-nowrap cursor-pointer"
              >
                Visit Us
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}